/**
 * Created by rouven on 21.12.17.
 */
import { actionTypes } from '@wikom/wikom-data';
import { SEND_DATA_FAILURE } from '../../common/actions/actionTypes';
/**
 * Redirects to different routes depending on HTTP Status Code
 * @param {Object} target
 * @param {Function} replace
 */
var httpErrorMiddleware = function (target, replace) { return function (_) { return function (next) { return function (action) {
    if ((action.type === actionTypes.LOAD_DATA_FAILURE || action.type === SEND_DATA_FAILURE)
        && action.error.hasOwnProperty('status')
        && target.hasOwnProperty(action.error.status)) {
        replace(target[action.error.status]);
    }
    return next(action);
}; }; }; };
export default httpErrorMiddleware;
